/// <amd-module name="VSS/Features/Charts/FunnelChart" />
import Highcharts = require("highcharts");

import * as Charts_Contracts from "VSS/Features/Charts/Contracts";
import { ChartTypesRegistry } from "VSS/Features/Charts/Internal/ChartTypesRegistry";
import { CommonChartImplementation } from "VSS/Features/Charts/Internal/CommonChartImplementation";
import { TooltipFormatterPoint } from "VSS/Features/Charts/Internal/TooltipFormatter";
import * as Charts_Resources from "VSS/Features/Charts/Resources";

export class FunnelChartConstants {
    /** A flexible chart which renders the charts using the chart types specified via the customOptions.chartTypes array. */
    public static Funnel: string = "funnel";
}

/* Note: Marketplace team is the primary consumer of Funnel */
class FunnelChartImplementation extends CommonChartImplementation {
    /* Expose the neccessary set of plot option defaults.*/

    constructor() {
        super();
        this._injectAxisNames = true;
    }

    public isOneDimensional(): boolean {
        return true;
    }

    public hasLegendByDefault(): boolean {
        return true;
    }

    public getTooltipHeaderValue(formatterPoint: TooltipFormatterPoint): string | number {
        // The point doesn't have a category but rather a name
        return formatterPoint.point.name;
    }

    public translatePlotOptions(chartOptions: Charts_Contracts.ChartProps): Highcharts.PlotOptions {
        const plotOptions: Highcharts.PlotOptions = super.translatePlotOptions(chartOptions);

        plotOptions.funnel = {
            dataLabels: {
                enabled: false,
                style: {
                    textOutline: "false",
                    fontWeight: "normal"
                }
            },

            states: {
                hover: {
                    enabled: false
                }
            },
            point: {
                events: {
                    click: (event: Highcharts.PointClickEventObject) => {
                        return true;
                    }
                }
            },
            showInLegend: true
        };

        const funnelChartOptions = chartOptions.specializedOptions as Charts_Contracts.FunnelChartOptions | undefined;
        if (funnelChartOptions) {
            if (funnelChartOptions.neckHeight) {
                plotOptions.funnel.neckHeight = funnelChartOptions.neckHeight;
            }
            if (funnelChartOptions.neckWidth) {
                plotOptions.funnel.neckWidth = funnelChartOptions.neckWidth;
            }
            if (funnelChartOptions.height) {
                plotOptions.funnel.height = funnelChartOptions.height;
            }
            if (funnelChartOptions.width) {
                plotOptions.funnel.width = funnelChartOptions.width;
            }
        }

        return plotOptions;
    }

    public translateTooltipOptions(tooltipOptions: Charts_Contracts.TooltipOptions): Highcharts.TooltipOptions {
        const translatedOptions = super.translateTooltipOptions(tooltipOptions);

        // In version 5.0.12 of highcharts, setting shared to true, our framework's default, causes the tooltip to not show for funnel.
        if (tooltipOptions == null || tooltipOptions.onlyShowFocusedSeries == null) {
            translatedOptions.shared = false;
        }

        return translatedOptions;
    }
}
ChartTypesRegistry.getInstance().registerChartType({
    chartTypeName: FunnelChartConstants.Funnel,
    constructor: FunnelChartImplementation,
    userFacingChartTypeName: Charts_Resources.ChartType_A11yLabel_Funnel
});
